// WhatsApp click-to-chat — used both as a floating site-wide CTA and inline on product pages.
// To change the destination number, edit the constant below.
const WA_NUMBER = "918288852339"; // +91 82888 52339

export function buildWaLink(message) {
  const text = encodeURIComponent(message || "Hello White Molar, I'd like to enquire about your dental equipment.");
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

// Official WhatsApp glyph as inline SVG (stroke 1.5 alternative not available — solid mark is the brand spec).
function WhatsAppGlyph({ size = 20, className = "" }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} className={className} aria-hidden="true">
      <path
        fill="currentColor"
        d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.345 0 2.19-.515 2.49-.804.36-.345.388-1.046.388-1.39 0-.144-.117-.115-.272-.215-.4-.215-.873-.4-1.288-.575M16 0C7.165 0 0 7.165 0 16c0 2.962.81 5.74 2.218 8.124L0 32l8.094-2.146A15.97 15.97 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0m0 28.83a12.83 12.83 0 0 1-6.85-1.978l-.49-.291-5.05 1.33 1.353-4.93-.32-.508A12.81 12.81 0 0 1 3.166 16C3.166 8.91 8.91 3.167 16 3.167c7.09 0 12.834 5.744 12.834 12.833 0 7.09-5.744 12.83-12.834 12.83"
      />
    </svg>
  );
}

export function WhatsAppButton({ message, label = "Chat on WhatsApp", className = "" }) {
  return (
    <a
      href={buildWaLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-inline-btn"
      className={`inline-flex items-center gap-2 px-6 py-3 border transition-colors font-medium text-sm bg-[#25D366] border-[#25D366] text-white hover:bg-[#1ebe5d] ${className}`}
    >
      <WhatsAppGlyph size={16} /> {label}
    </a>
  );
}

export function WhatsAppFloating() {
  return (
    <a
      href={buildWaLink("Hello White Molar, I have a question about your equipment.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-lg shadow-emerald-900/20 hover:bg-[#1ebe5d] transition-colors"
    >
      <WhatsAppGlyph size={22} />
      <span className="text-sm font-medium hidden sm:inline">Chat with us</span>
    </a>
  );
}
